import { Component } from 'react';
import {
  getCoinsSettings,
  insertCoinPack,
  insertCouponCode,
  updateCoinPack,
} from './../../services/apiService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class CoinsSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      coinsPack: [],
      couponCode: [],
      addNewCouponPanel: true,
      prevCoinSettings: {},
      newCouponCode: {
        couponName: '',
        discountAmount: 0,
        validForGroups: [],
        validForUsers: '',
        validOnCoinPack: '',
        validTill: '',
      },
      saveBtnText: 'Save Settings',
    };
  }

  componentDidMount = async () => {
    const coinSetting = await getCoinsSettings();
    this.setState({
      prevCoinSettings: { ...coinSetting },
      coinsPack: [...coinSetting.coinPacks],
      couponCode: [...coinSetting.coinCoupons],
    });
  };

  addCoinPack = () => {
    const x = {
      packName: '',
      regularPrice: 0,
      discountedPrice: 0,
      noOfCoins: 0,
    };
    const coinsArr = this.state.coinsPack;
    coinsArr.push(x);
    this.setState({ coinsPack: [...coinsArr] });
  };

  updateCoinPackData = (event, value, index) => {
    const coinPacks = this.state.coinsPack;
    coinPacks[index] = { ...coinPacks[index], [value]: event.target.value };
    this.setState({ coinsPack: [...coinPacks] });
  };

  getCoinPackFromId = (packId) => {
    const allCoinPack = this.state.coinsPack;
    const pack = allCoinPack.find(({ ...elem }) => elem.id === packId);
    return pack?.packName || '';
  };

  checkDuplicateCouponCode = (couponCode) => {
    const allCoinPacks = this.state.prevCoinSettings.coinCoupons;
    const matchedCoupon = allCoinPacks.find(
      (elem) => elem.couponName === couponCode
    );
    if (matchedCoupon) {
      return true;
    }
    return false;
  };

  deleteCoinPack = (idToRemove) => {
    const allCoinPack = this.state.coinsPack;
    const filterArray = allCoinPack.filter((item) => item.id !== idToRemove);
    this.setState({ coinsPack: [...filterArray] });
  };

  notify = (text) => {
    toast.dark(text, {
      position: 'bottom-center',
      autoClose: 2200,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      limit: 1,
    });
  };

  refreshSettings = async () => {
    const coinSetting = await getCoinsSettings();
    this.setState({
      coinsPack: [...coinSetting.coinPacks],
      couponCode: [...coinSetting.coinCoupons],
      saveBtnText: 'Save Settings',
    });
  };

  saveSettings = async () => {
    this.setState({ saveBtnText: 'Saving...' });
    const coinsPack = this.state.coinsPack;
    const newCouponCode = this.state.newCouponCode;
    let resp, resp2; // resp-> couponCode response & resp2 -> CoinPack response

    if (newCouponCode.couponName !== '') {
      if (this.checkDuplicateCouponCode(newCouponCode.couponName)) {
        alert('Coupon Code Already Exists');
        this.setState({ saveBtnText: 'Save Session' });
        return;
      }
      resp2 = await insertCouponCode(newCouponCode);
    }

    for (let i = 0; i < coinsPack.length; i++) {
      const pack = coinsPack[i];
      const coinPackObj = {
        packName: pack.packName,
        regularPrice: Number(pack.regularPrice),
        discountedPrice: Number(pack.discountedPrice),
        noOfCoins: Number(pack.noOfCoins),
      };

      if (pack.id) {
        const prevSettings = this.state.prevCoinSettings.coinPacks[i];
        if (
          prevSettings.packName !== pack.packName ||
          prevSettings.noOfCoins !== pack.noOfCoins ||
          prevSettings.discountedPrice !== pack.discountedPrice ||
          prevSettings.regularPrice !== pack.regularPrice
        ) {
          resp = await updateCoinPack({ ...coinPackObj, id: pack.id });
        }
      } else {
        resp = await insertCoinPack(coinPackObj);
      }
    }

    if (resp && resp2) {
      this.notify('Coins Settings Updated Successfully');
      await this.refreshSettings();
    } else if (resp && !resp2) {
      this.notify(' Coupon Code Updated Successfully');
      await this.refreshSettings();
    } else {
      await this.notify('No Changes Detected');
      await this.refreshSettings();
    }
  };

  render() {
    return (
      <div className='w-4/5'>
        <h1 className='text-gray-700 text-3xl font-bold'>Coins Settings</h1>
        <br />
        <div className='bg-white p-11'>
          <h1 className='text-gray-500 font-bold text-lg my-5'>
            Coins Pricing
          </h1>
          <table className='table-auto'>
            <thead>
              <tr>
                <th className='text-left text-gray-400'>Pack Name</th>
                <th className='text-left text-gray-400'>Regular Price</th>
                <th className='text-left text-gray-400'>Discounted Price</th>
                <th className='text-left text-gray-400'>No Of Coins</th>
              </tr>
            </thead>
            <tbody>
              {this.state.coinsPack.map((cp, index) => (
                <tr className='w-full text-gray-500' key={`pack-${index}`}>
                  <td className='pr-5 my-3'>
                    <input
                      value={cp?.packName}
                      onChange={(e) =>
                        this.updateCoinPackData(e, 'packName', index)
                      }
                      placeholder='Pack name'
                      type='text'
                      className='px-2 py-2 border border-gray-300 rounded'
                    />
                  </td>
                  <td className='pr-5 my-3'>
                    <input
                      type='number'
                      value={cp?.regularPrice}
                      onChange={(e) =>
                        this.updateCoinPackData(e, 'regularPrice', index)
                      }
                      className='px-2 py-2 border border-gray-300 rounded'
                    />
                  </td>
                  <td className='pr-5 my-3'>
                    <input
                      type='number'
                      value={cp?.discountedPrice}
                      onChange={(e) =>
                        this.updateCoinPackData(e, 'discountedPrice', index)
                      }
                      className='px-2 py-2 border border-gray-300 rounded'
                    />
                  </td>
                  <td className='pr-5 my-3'>
                    <input
                      type='number'
                      value={cp?.noOfCoins}
                      onChange={(e) =>
                        this.updateCoinPackData(e, 'noOfCoins', index)
                      }
                      className='px-2 py-2 border border-gray-300 rounded'
                    />
                  </td>
                  <td>
                    <i
                      onClick={() => {
                        this.deleteCoinPack(cp.id);
                      }}
                      className='ml-3 text-gray-300 text-2xl fas fa-trash-alt'
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <br />
          <span
            className='mt-5 cursor-pointer text-blue-500'
            onClick={this.addCoinPack}
          >
            + Add Coin Pack
          </span>
          <br />
          <br />
          <hr className='border border-gray-300' />
          <h1 className='font-bold mt-5 mb-3 text-gray-500 text-xl'>
            Coupon Code
          </h1>
          <br />
          <hr className='my-3 border border-gray-400' />
          {this.state.couponCode.map((ccode, index) => (
            <div
              className='my-5 flex justify-evenly grid grid-flow-col'
              key={`couponcode-${index}`}
            >
              <div>
                <span className='text-gray-400 text-sm'>Coupon Code</span>
                <br />
                <span className='font-bold'>{ccode.couponName}</span>
              </div>
              <div>
                <span className='text-gray-400 text-sm'>Discount Amt</span>
                <br />
                <span>₹ {ccode.discountAmount}</span>
              </div>
              <div>
                <span className='text-gray-400 text-sm'>Valid On</span>
                <br />
                <span>
                  {ccode.validOnCoinPack !== ''
                    ? this.getCoinPackFromId(ccode.validOnCoinPack)
                    : 'Everyone'}
                </span>
              </div>
              <div>
                <span className='text-gray-400 text-sm'>Valid Till</span>
                <br />
                <span>{ccode.validTill}</span>
              </div>
              <div>
                <span className='text-gray-400 text-sm'>Valid For</span>
                <br />
                <span>{ccode.validForGroups}</span>
              </div>
              <div>
                <span className='text-gray-400 text-sm'>Used</span>
                <br />
                <span>{ccode.used}</span>
              </div>
              <div>
                <i className='text-gray-400 text-2xl fas fa-trash-alt' />
              </div>
            </div>
          ))}
          <hr className='my-3 border border-gray-300' />

          <span
            className='text-blue-500 cursor-pointer'
            hidden={!this.state.addNewCouponPanel}
            onClick={(e) => {
              this.setState({ addNewCouponPanel: false });
            }}
          >
            Add New Coupon
          </span>

          <div
            className='mt-5 add-new-coupon'
            hidden={this.state.addNewCouponPanel}
          >
            <div className='grid grid-cols-2 w-2/3 gap-4'>
              <div>
                <span className='text-gray-400 text-md'>Coupon Code</span>
                <br />
                <input
                  type='text'
                  placeholder='XXXX'
                  className='w-full px-3 py-2 border border-gray-300 rounded'
                  onChange={(e) =>
                    this.setState({
                      newCouponCode: {
                        ...this.state.newCouponCode,
                        couponName: e.target.value.toUpperCase(),
                      },
                    })
                  }
                  value={this.state.newCouponCode.couponName}
                  required={true}
                />
              </div>
              <div>
                <span className='text-gray-400 text-md'>Discount Amt</span>
                <br />
                <input
                  type='number'
                  placeholder='₹'
                  className='w-full px-3 py-2 border border-gray-300 rounded'
                  onChange={(e) =>
                    this.setState({
                      newCouponCode: {
                        ...this.state.newCouponCode,
                        discountAmount: e.target.value,
                      },
                    })
                  }
                  value={this.state.newCouponCode.discountAmount}
                  required={true}
                />
              </div>
              <div>
                <span className='text-gray-400 text-md'>Select Coin Pack</span>
                <br />
                <select
                  onChange={(e) =>
                    this.setState({
                      newCouponCode: {
                        ...this.state.newCouponCode,
                        validOnCoinPack: e.target.value,
                      },
                    })
                  }
                  value={this.state.newCouponCode.validOnCoinPack}
                  className='w-full px-3 py-2 border border-gray-300 rounded'
                  required={true}
                >
                  <option value=''>Apply on all</option>
                  {this.state.coinsPack.map((cp, index) => (
                    <option key={index} value={cp.id}>
                      {cp.packName}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <span className='text-gray-400 text-md'>Valid Till</span>
                <br />
                <input
                  type='date'
                  className='w-full px-3 py-2 border border-gray-300 rounded'
                  onChange={(e) =>
                    this.setState({
                      newCouponCode: {
                        ...this.state.newCouponCode,
                        validTill: e.target.value,
                      },
                    })
                  }
                  value={this.state.newCouponCode.validTill}
                  required={true}
                />
              </div>
            </div>
            <div className='w-2/3'>
              <input
                type='text'
                placeholder='Search for users/groups'
                className='w-full mt-5 border border-gray-300 px-3 py-2'
                onChange={(e) =>
                  this.setState({
                    newCouponCode: {
                      ...this.state.newCouponCode,
                      validForUsers: e.target.value,
                    },
                  })
                }
                value={this.state.newCouponCode.validForUsers}
                required={true}
              />
              <br />
              <input type='checkbox' className='mt-5 h-4 w-4 form-tick' /> Valid
              For Everyone
            </div>
          </div>
          <br />
          <br />
          <button
            onClick={this.saveSettings}
            className='bg-blue-500 text-white px-5 py-2 '
          >
            {this.state.saveBtnText}
          </button>
          <br />
        </div>
      </div>
    );
  }
}

export default CoinsSettings;
